import { NgModule, inject } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideApollo } from 'apollo-angular';
import { InMemoryCache } from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';

import { environment } from '../environments/environment';
import { authInterceptor } from './auth/auth.interceptor';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SitesListComponent } from './sites-list/sites-list.component';

import { SiteManageComponent } from './site-manage/site-manage.component';
import { SettingsComponent } from './site-manage/settings/settings.component';
import { PagesComponent } from './site-manage/pages/pages.component';
import { PageComponent } from './site-manage/pages/page/page.component';
import { ProfilesComponent } from './site-manage/profiles/profiles.component';
import { ProfileComponent } from './site-manage/profiles/profile/profile.component';
import { UsersComponent } from './site-manage/users/users.component';
import { NavigationComponent } from './site-manage/navigation/navigation.component';
import { RedirectsComponent } from './site-manage/redirects/redirects.component';
import { ArticlesComponent } from './site-manage/articles/articles.component';
import { ArticleComponent } from './site-manage/articles/article/article.component';
import { SiteFormComponent } from './shared/site-form/site-form.component';
import { ConfirmationModalComponent } from './shared/confirmation-modal/confirmation-modal.component';
import { ToastComponent } from './shared/toast/toast.component';
import { TiptapEditorComponent } from './shared/tiptap-editor/tiptap-editor.component';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { LoginComponent } from './auth/login/login.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { AcceptInviteComponent } from './auth/accept-invite/accept-invite.component';
import { DomainsComponent } from './domains/domains.component';
import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { PlatformUsersComponent } from './platform-users/platform-users.component';

@NgModule({ declarations: [
        AppComponent,
        SitesListComponent,
        SiteManageComponent,
        SettingsComponent,
        PagesComponent,
        PageComponent,
        ProfilesComponent,
        ProfileComponent,
        UsersComponent,
        NavigationComponent,
        RedirectsComponent,
        ArticlesComponent,
        ArticleComponent,
        SiteFormComponent,
        ConfirmationModalComponent,
        ToastComponent,
        TiptapEditorComponent,
        SpinnerComponent,
        LoginComponent,
        ForgotPasswordComponent,
        AcceptInviteComponent,
        DomainsComponent,
        AdminLayoutComponent,
        PlatformUsersComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule,
    ], providers: [
        provideHttpClient(withInterceptors([authInterceptor])),
        provideApollo(() => {
            const httpLink = inject(HttpLink);
            return {
                link: httpLink.create({ uri: environment.apiUrl }),
                cache: new InMemoryCache(),
            };
        }),
    ] })
export class AppModule { }
